module.exports = __webpack_public_path__ + "media/thepart.b2ae0a7a.mp3";